import React, { PureComponent } from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import { Grid, Column, Row, Button, Heading, cls } from '../../packages/components';
import RequestManager from '../../requests/RequestManager';
import Translator from '../../requests/apa/Translator';
import LogoutTask from '../../requests/tasks/user/LogoutTask';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from './../../store';
import Utils from '../../utils/Utils';
import UtilsProfile from './../../utils/Profile';
import { playFullMedia } from '../../actions/playmedia';
import Asset from '../../requests/apa/Asset';
import Device from '../../devices/device';
import './styles/AAFModalProfile.scss';

class AAFModalProfile extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            step: 'first',
            type: '',
        };
        this.device = Device.getDevice().getPlatform();
        this.customizedClassName = `modal-button-return`;
        this.p = {
            alwaysEnabled: true,
            aafNewStyle: true,
            className: 'aaf-modal',
            showLogo: true,
            yellowAction: () => this.props.handleClose(),
            colorButtons: [
                {
                    content: Translator.get('top_head_option_button_back', 'REGRESAR'),
                    props: {
                        color: 'yellow',
                        className: this.customizedClassName,
                        imgSrc: Asset.get('top_head_option_back', ''),
                        onClick: (e) => this.props.handleClose(),
                    },
                },
            ],
        };
    }

    logOut = () => {
        const service = new LogoutTask();
        RequestManager.addRequest(service)
            .then((resp) => {
                if (resp.response) {
                    const ui = DeviceStorage.getItem('__UUID__');
                    const hadLoginSuccess = DeviceStorage.getItem('hadLoginSuccess');
                    store.dispatch(playFullMedia({ src: null, event: null }));
                    DeviceStorage.clear();

                    const platform = Device.getDevice().getPlatform();
                    const isAndroid = platform === 'android';
                    try {
                        if (isAndroid && window.AndroidPlayerInterface) {
                            window.AndroidPlayerInterface.getUserInformation();
                        }
                    } catch (error) {
                        console.log('[ERROR]-error on getUserInformation', error);
                    }

                    DeviceStorage.setItem('__UUID__', ui);
                    DeviceStorage.setItem('IsLogOut', true);
                    if (hadLoginSuccess === '1') DeviceStorage.setItem('hadLoginSuccess', '1');
                    Utils.cleanCustomAttribute();
                    window.location.href = '/';
                }
            })
            .catch((err) => {
                console.error(err);
            });
    };

    getButtons() {
        const {
            handleClose,
            callback,
            gamificationId,
            enableSocialProfile,
            enableSessionRefresh,
            enableAbout,
        } = this.props;
        const { profile } = store.getState();
        const { user } = store.getState();
        const LogOutButton = Utils.getApaMetadataKey('is_logout_visible', '{false}');
        const buttons = [];

        if (UtilsProfile.isProfileEnable(user)) {
            if (profile && profile.admin) {
                buttons.push({
                    id: 'ajustes',
                    title: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
                    onClick: (e) => handleClose(e, callback('user-settings/idioma')),
                });

                buttons.unshift({
                    id: 'administrar',
                    title: Translator.get('menu_manage_profiles_label', 'Administrar Perfiles'),
                    onClick: (e) => {
                        handleClose(e, callback('profile/admin', false, null));
                    },
                });
            }

            profile.members &&
                profile.members.map((m) => {
                    return buttons.push({
                        id: m.username,
                        title: m.username,
                        onClick: (e) => {
                            handleClose(e, callback('profile', null, m));
                        },
                        img: `${m.user_image}&impolicy=resize&vwidth=27`,
                    });
                });
        } else {
            buttons.push({
                id: 'ajustes',
                title: Translator.get('stb_social_settings', 'Ajustes de Perfil'),
                onClick: (e) => handleClose(e, callback('user-settings/idioma')),
            });
            if (enableSocialProfile) {
                buttons.unshift({
                    title: Translator.get('social_profile_card_header', 'Mi Perfil'),
                    onClick: (e) => {
                        handleClose(e, callback(`socialProfile/${gamificationId}`));
                    },
                });
            }
        }

        if (enableAbout) {
            buttons.push({
                id: 'acerca',
                title: Translator.get('about_card_header', 'Acerca de'),
                onClick: (e) => {
                    handleClose(e, callback('about'));
                },
            });
        }

        if (enableSocialProfile && profile && profile.admin) {
            buttons.unshift({
                id: 'perfil',
                title: Translator.get('social_profile_card_header', 'Mi Perfil'),
                onClick: (e) => {
                    handleClose(e, callback(`socialProfile/${gamificationId}`));
                },
            });
        }

        if (enableSessionRefresh) {
            buttons.unshift({
                id: 'refrescar',
                title: Translator.get('btn_session_refresh', 'Refrescar sesión'),
                onClick: (e) => {
                    handleClose(e, callback(null, true));
                },
            });
        }

        if (LogOutButton) {
            buttons.push({
                id: 'cerrar',
                title: Translator.get('social_close_session', 'Cerrar Sesion'),
                onClick: () => this.logOut(),
            });
        }

        return buttons.map((b) => {
            return (
                <Column lg={10} className="aaf_modal-space-button-profile" key={b.id}>
                    <Button
                        activate
                        type="button"
                        block
                        className={cls('focusable', 'buttons-profile')}
                        onClick={b.onClick}
                    >
                        {b.img && <img src={b.img} alt={b.img} />}
                        {<span>{b.title}</span>}
                        {<i className="fa fa-chevron-right" id="btns-right" />}
                    </Button>
                </Column>
            );
        });
    }

    stepButtons(step) {
        this.setState({ step });
    }

    getHelpInfo() {
        return (
            <Grid>
                <Row>
                    <Column lg={12}>
                        <Heading size={1}>{Translator.get('', 'Ayuda')}</Heading>
                    </Column>
                    <Column lg={12}>
                        <span>{Translator.get('', '¿Necesitas ayuda?')}</span>
                    </Column>
                </Row>
                <Row>
                    <Column lg={6}>
                        <p>Escanea el código con la cámara de tu smartphone.</p>
                        <p>
                            O entra a la siguiente dirección desde tu navegador:
                            www.clarovideo.com/ayuda
                        </p>
                    </Column>
                    <Column lg={6}>
                        <img src="" alt="" />
                    </Column>
                </Row>
            </Grid>
        );
    }

    render() {
        const { step, type } = this.state;
        return (
            <ModalWrapper {...this.p}>
                {type && this.getHelpInfo()}
                {!type && (
                    <Grid>
                        <Row>
                            {step === 'second' && (
                                <Column lg={12}>
                                    <Heading size={1}>
                                        {Translator.get('', 'Configuraciones y ayuda')}
                                    </Heading>
                                </Column>
                            )}
                            <Column lg={6} className='aaf_modal-image'>
                                <img
                                    src={
                                        Asset.get('menu_access_icon_avatars', false) ||
                                        'http://clarovideocdn7.clarovideo.net/pregeneracion/cms/apa/uat_a9028c58f218a7afd2d32ad11d0058e0/logo_clarotv.png?1586870669'
                                    }
                                    alt="config"
                                />
                            </Column>
                            <Column lg={6}>{this.getButtons()}</Column>
                        </Row>
                    </Grid>
                )}
            </ModalWrapper>
        );
    }
}

export default withOnClose(AAFModalProfile);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalProfile.jsx